import React, { useEffect, useState, useContext } from 'react'
import { queryAttachmentService } from '../../../services/RenderImageService';
import { LoginContext } from '../../../context/LoginContext';
import { X } from 'lucide-react';
import "./RenderImage.css";

interface RenderImageProps {
    photo?: string
}

function DisplayPdf({
    url,
    setShowPopup,
    showPopup
}: {
    url: string
    showPopup: boolean
    setShowPopup: React.Dispatch<React.SetStateAction<boolean>>
}) {
    return (
        <div className="render-pdf-overlay">
            <div className="render-pdf-container">
                <button
                    className="render-app-popup-close"
                    onClick={() => setShowPopup(false)}
                >
                    <X size={20} />
                </button>
                <embed src={url ?? ""} type="application/pdf" className="render-pdf-embed" />
            </div>
        </div>
    )
}

function RenderImage({
    photo
}: RenderImageProps) {
    const { user } = useContext(LoginContext);
    const [imageUrl, setImageUrl] = useState<string | null>(null);
    const [blobType, setBlobType] = useState<string | null>(null);
    const [showPopup, setShowPopup] = useState(false);

    const fetchAttachment = async (document_id: string, user_id: string) => {
        try {
            const attachment = await queryAttachmentService.getAttachment(document_id, user_id);
            return attachment
        } catch (error) {
            console.error("Error fetching drives:", error);
        }
    };

    const userId = user?.userId || "";

    useEffect(() => {
        if (photo && userId) {
            const attachmentBlob = fetchAttachment(photo, userId)
            attachmentBlob.then((blob) => {
                if (blob !== undefined) {
                    setBlobType(blob?.type)
                    const url = URL.createObjectURL(blob);
                    setImageUrl(url);
                }
            })
        };
    }, [photo, userId])

    if (!photo) return null
    return (
        blobType === "application/pdf" ?
            <div className="render-pdf-container-wrapper">
                {showPopup &&
                    <DisplayPdf
                        url={imageUrl ?? ''}
                        showPopup={showPopup}
                        setShowPopup={setShowPopup}
                    />
                }
                <div className="render-pdf-view-button-wrapper">
                    <button className="render-view-pdf-button" onClick={() => setShowPopup(true)}>
                        View PDF
                    </button>
                </div>
            </div>
            :
            (
                <div className="render-image-container">
                    <div className="render-image-wrapper">
                        <img src={imageUrl ?? ''} alt="Blob content" className="render-preview-image" />
                    </div>
                </div>
            )
    )
}

export default RenderImage